export class AnimatedValue {
  constructor(value) {
    this.value = value;
  }

  getAnimatedValue() {
    return this.value;
  }

  setValue(value) {
    this.value = value;
  }
}
